import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BarChart3, TrendingUp, Users, Target, DollarSign, Award, AlertCircle, Globe, ArrowRight, ArrowLeft } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, ComposedChart, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Area, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';

const Silvuranalysis = ({ onSectionChange }) => {
  const navigate = useNavigate();
  const [selectedRegion, setSelectedRegion] = useState('both'); // 'germany', 'us', or 'both'

  // Format currency helper
  const formatCurrency = (value) => {
    return `$${value.toLocaleString()}`;
  };

  // Germany data
  const germanyData = [
    { age: 18, activeMembers: 380, ddMembers: 66, avgDD: 1558, ddPercent: 17 },
    { age: 19, activeMembers: 682, ddMembers: 205, avgDD: 2249, ddPercent: 30 },
    { age: 20, activeMembers: 1068, ddMembers: 411, avgDD: 2512, ddPercent: 38 },
    { age: 21, activeMembers: 1241, ddMembers: 533, avgDD: 2835, ddPercent: 43 },
    { age: 22, activeMembers: 1475, ddMembers: 646, avgDD: 3267, ddPercent: 44 },
    { age: 23, activeMembers: 1757, ddMembers: 773, avgDD: 3405, ddPercent: 44 },
    { age: 24, activeMembers: 1974, ddMembers: 878, avgDD: 3478, ddPercent: 44 },
    { age: 25, activeMembers: 1925, ddMembers: 864, avgDD: 3538, ddPercent: 45 },
    { age: 26, activeMembers: 1871, ddMembers: 843, avgDD: 3467, ddPercent: 45 },
    { age: 27, activeMembers: 1775, ddMembers: 773, avgDD: 3871, ddPercent: 44 },
    { age: 28, activeMembers: 1617, ddMembers: 682, avgDD: 4066, ddPercent: 42 },
    { age: 29, activeMembers: 1558, ddMembers: 668, avgDD: 3603, ddPercent: 43 },
    { age: 30, activeMembers: 1572, ddMembers: 719, avgDD: 4187, ddPercent: 46 },
    { age: 31, activeMembers: 1554, ddMembers: 690, avgDD: 4160, ddPercent: 44 },
    { age: 32, activeMembers: 1407, ddMembers: 624, avgDD: 4026, ddPercent: 44 },
    { age: 33, activeMembers: 1412, ddMembers: 673, avgDD: 4203, ddPercent: 48 },
    { age: 34, activeMembers: 1364, ddMembers: 696, avgDD: 4434, ddPercent: 51 },
    { age: 35, activeMembers: 1414, ddMembers: 693, avgDD: 4493, ddPercent: 49 },
    { age: 36, activeMembers: 1318, ddMembers: 655, avgDD: 4799, ddPercent: 50 },
    { age: 37, activeMembers: 1292, ddMembers: 625, avgDD: 4521, ddPercent: 48 },
    { age: 38, activeMembers: 1183, ddMembers: 620, avgDD: 4542, ddPercent: 52 },
    { age: 39, activeMembers: 1205, ddMembers: 609, avgDD: 4790, ddPercent: 51 },
    { age: 40, activeMembers: 1167, ddMembers: 585, avgDD: 4700, ddPercent: 50 },
    { age: 41, activeMembers: 1092, ddMembers: 569, avgDD: 5078, ddPercent: 52 },
    { age: 42, activeMembers: 1072, ddMembers: 567, avgDD: 5209, ddPercent: 53 },
    { age: 43, activeMembers: 1022, ddMembers: 572, avgDD: 5418, ddPercent: 56 },
    { age: 44, activeMembers: 932, ddMembers: 527, avgDD: 5644, ddPercent: 57 },
    { age: 45, activeMembers: 858, ddMembers: 475, avgDD: 5729, ddPercent: 55 },
    { age: 46, activeMembers: 776, ddMembers: 440, avgDD: 5660, ddPercent: 57 },
    { age: 47, activeMembers: 732, ddMembers: 410, avgDD: 6251, ddPercent: 56 },
    { age: 48, activeMembers: 714, ddMembers: 398, avgDD: 5517, ddPercent: 56 },
    { age: 49, activeMembers: 628, ddMembers: 381, avgDD: 6244, ddPercent: 61 },
    { age: 50, activeMembers: 612, ddMembers: 350, avgDD: 5850, ddPercent: 57 },
    { age: 51, activeMembers: 618, ddMembers: 381, avgDD: 6436, ddPercent: 62 },
    { age: 52, activeMembers: 551, ddMembers: 331, avgDD: 5889, ddPercent: 60 },
    { age: 53, activeMembers: 522, ddMembers: 307, avgDD: 6727, ddPercent: 59 },
    { age: 54, activeMembers: 533, ddMembers: 303, avgDD: 7017, ddPercent: 57 },
    { age: 55, activeMembers: 520, ddMembers: 304, avgDD: 5775, ddPercent: 58 },
    { age: 56, activeMembers: 555, ddMembers: 334, avgDD: 6303, ddPercent: 60 },
    { age: 57, activeMembers: 494, ddMembers: 308, avgDD: 6706, ddPercent: 62 },
    { age: 58, activeMembers: 479, ddMembers: 285, avgDD: 5525, ddPercent: 59 },
    { age: 59, activeMembers: 476, ddMembers: 285, avgDD: 6358, ddPercent: 60 },
    { age: 60, activeMembers: 441, ddMembers: 260, avgDD: 7803, ddPercent: 59 },
    { age: 61, activeMembers: 478, ddMembers: 294, avgDD: 5914, ddPercent: 62 },
    { age: 62, activeMembers: 432, ddMembers: 256, avgDD: 6544, ddPercent: 59 },
    { age: 63, activeMembers: 429, ddMembers: 255, avgDD: 6024, ddPercent: 59 },
    { age: 64, activeMembers: 383, ddMembers: 214, avgDD: 6528, ddPercent: 56 },
    { age: 65, activeMembers: 347, ddMembers: 191, avgDD: 5618, ddPercent: 55 },
    { age: 66, activeMembers: 340, ddMembers: 185, avgDD: 5591, ddPercent: 54 },
    { age: 67, activeMembers: 262, ddMembers: 148, avgDD: 5981, ddPercent: 56 },
    { age: 68, activeMembers: 252, ddMembers: 135, avgDD: 4154, ddPercent: 54 },
    { age: 69, activeMembers: 267, ddMembers: 126, avgDD: 4487, ddPercent: 47 },
    { age: 70, activeMembers: 214, ddMembers: 125, avgDD: 4741, ddPercent: 58 },
    { age: 71, activeMembers: 210, ddMembers: 102, avgDD: 5422, ddPercent: 49 },
    { age: 72, activeMembers: 175, ddMembers: 85, avgDD: 3900, ddPercent: 49 },
    { age: 73, activeMembers: 159, ddMembers: 75, avgDD: 3732, ddPercent: 47 },
    { age: 74, activeMembers: 146, ddMembers: 81, avgDD: 4673, ddPercent: 55 },
    { age: 75, activeMembers: 135, ddMembers: 70, avgDD: 3741, ddPercent: 52 },
    { age: 76, activeMembers: 111, ddMembers: 49, avgDD: 0, ddPercent: 44 },
    { age: 77, activeMembers: 133, ddMembers: 67, avgDD: 4655, ddPercent: 50 },
    { age: 78, activeMembers: 108, ddMembers: 55, avgDD: 3996, ddPercent: 51 },
    { age: 79, activeMembers: 114, ddMembers: 58, avgDD: 4358, ddPercent: 51 },
    { age: 80, activeMembers: 82, ddMembers: 40, avgDD: 3295, ddPercent: 49 }
  ];

  // United States data
  const usData = [
    { age: 18, activeMembers: 2251, ddMembers: 561, avgDD: 1583, ddPercent: 25 },
    { age: 19, activeMembers: 2691, ddMembers: 805, avgDD: 1947, ddPercent: 30 },
    { age: 20, activeMembers: 3093, ddMembers: 1001, avgDD: 2391, ddPercent: 32 },
    { age: 21, activeMembers: 3202, ddMembers: 1073, avgDD: 2539, ddPercent: 34 },
    { age: 22, activeMembers: 3753, ddMembers: 1345, avgDD: 2839, ddPercent: 36 },
    { age: 23, activeMembers: 4308, ddMembers: 1576, avgDD: 3207, ddPercent: 37 },
    { age: 24, activeMembers: 4741, ddMembers: 1822, avgDD: 3389, ddPercent: 38 },
    { age: 25, activeMembers: 5197, ddMembers: 2021, avgDD: 3766, ddPercent: 39 },
    { age: 26, activeMembers: 5421, ddMembers: 2112, avgDD: 3998, ddPercent: 39 },
    { age: 27, activeMembers: 5820, ddMembers: 2216, avgDD: 4159, ddPercent: 38 },
    { age: 28, activeMembers: 5975, ddMembers: 2336, avgDD: 4501, ddPercent: 39 },
    { age: 29, activeMembers: 5930, ddMembers: 2315, avgDD: 4686, ddPercent: 39 },
    { age: 30, activeMembers: 6262, ddMembers: 2479, avgDD: 4734, ddPercent: 40 },
    { age: 31, activeMembers: 6235, ddMembers: 2531, avgDD: 4996, ddPercent: 41 },
    { age: 32, activeMembers: 6298, ddMembers: 2603, avgDD: 5112, ddPercent: 41 },
    { age: 33, activeMembers: 6404, ddMembers: 2617, avgDD: 4951, ddPercent: 41 },
    { age: 34, activeMembers: 6336, ddMembers: 2611, avgDD: 5114, ddPercent: 41 },
    { age: 35, activeMembers: 6486, ddMembers: 2695, avgDD: 5477, ddPercent: 42 },
    { age: 36, activeMembers: 6367, ddMembers: 2625, avgDD: 5340, ddPercent: 41 },
    { age: 37, activeMembers: 6256, ddMembers: 2702, avgDD: 5281, ddPercent: 43 },
    { age: 38, activeMembers: 6198, ddMembers: 2526, avgDD: 5660, ddPercent: 41 },
    { age: 39, activeMembers: 6158, ddMembers: 2514, avgDD: 5595, ddPercent: 41 },
    { age: 40, activeMembers: 6227, ddMembers: 2539, avgDD: 5784, ddPercent: 41 },
    { age: 41, activeMembers: 5994, ddMembers: 2518, avgDD: 5914, ddPercent: 42 },
    { age: 42, activeMembers: 5835, ddMembers: 2320, avgDD: 5721, ddPercent: 40 },
    { age: 43, activeMembers: 5886, ddMembers: 2357, avgDD: 5983, ddPercent: 40 },
    { age: 44, activeMembers: 5581, ddMembers: 2231, avgDD: 6022, ddPercent: 40 },
    { age: 45, activeMembers: 5492, ddMembers: 2176, avgDD: 5969, ddPercent: 40 },
    { age: 46, activeMembers: 5398, ddMembers: 2141, avgDD: 5856, ddPercent: 40 },
    { age: 47, activeMembers: 5037, ddMembers: 1947, avgDD: 6147, ddPercent: 39 },
    { age: 48, activeMembers: 4916, ddMembers: 1808, avgDD: 5993, ddPercent: 37 },
    { age: 49, activeMembers: 4634, ddMembers: 1769, avgDD: 6209, ddPercent: 38 },
    { age: 50, activeMembers: 4666, ddMembers: 1680, avgDD: 5903, ddPercent: 36 },
    { age: 51, activeMembers: 4792, ddMembers: 1797, avgDD: 5646, ddPercent: 38 },
    { age: 52, activeMembers: 4683, ddMembers: 1714, avgDD: 5744, ddPercent: 37 },
    { age: 53, activeMembers: 4948, ddMembers: 1854, avgDD: 5781, ddPercent: 37 },
    { age: 54, activeMembers: 5408, ddMembers: 2102, avgDD: 5754, ddPercent: 39 },
    { age: 55, activeMembers: 5514, ddMembers: 2034, avgDD: 5968, ddPercent: 37 },
    { age: 56, activeMembers: 5307, ddMembers: 1949, avgDD: 5807, ddPercent: 37 },
    { age: 57, activeMembers: 5081, ddMembers: 1899, avgDD: 5691, ddPercent: 37 },
    { age: 58, activeMembers: 5173, ddMembers: 1903, avgDD: 5594, ddPercent: 37 },
    { age: 59, activeMembers: 5123, ddMembers: 1820, avgDD: 5666, ddPercent: 36 },
    { age: 60, activeMembers: 5337, ddMembers: 2024, avgDD: 5346, ddPercent: 38 },
    { age: 61, activeMembers: 5343, ddMembers: 1959, avgDD: 5327, ddPercent: 37 },
    { age: 62, activeMembers: 5417, ddMembers: 1980, avgDD: 5418, ddPercent: 37 },
    { age: 63, activeMembers: 5076, ddMembers: 1887, avgDD: 4807, ddPercent: 37 },
    { age: 64, activeMembers: 5097, ddMembers: 1924, avgDD: 5135, ddPercent: 38 },
    { age: 65, activeMembers: 4900, ddMembers: 1736, avgDD: 4901, ddPercent: 35 },
    { age: 66, activeMembers: 4651, ddMembers: 1657, avgDD: 4751, ddPercent: 36 },
    { age: 67, activeMembers: 4436, ddMembers: 1666, avgDD: 4908, ddPercent: 38 },
    { age: 68, activeMembers: 4306, ddMembers: 1613, avgDD: 4821, ddPercent: 37 },
    { age: 69, activeMembers: 3900, ddMembers: 1411, avgDD: 4835, ddPercent: 36 },
    { age: 70, activeMembers: 3486, ddMembers: 1268, avgDD: 4631, ddPercent: 36 },
    { age: 71, activeMembers: 3354, ddMembers: 1267, avgDD: 4591, ddPercent: 38 },
    { age: 72, activeMembers: 3026, ddMembers: 1062, avgDD: 4911, ddPercent: 35 },
    { age: 73, activeMembers: 2746, ddMembers: 1033, avgDD: 4213, ddPercent: 38 },
    { age: 74, activeMembers: 2631, ddMembers: 1006, avgDD: 4064, ddPercent: 38 },
    { age: 75, activeMembers: 2424, ddMembers: 893, avgDD: 4269, ddPercent: 37 },
    { age: 76, activeMembers: 2345, ddMembers: 916, avgDD: 3986, ddPercent: 39 },
    { age: 77, activeMembers: 2260, ddMembers: 816, avgDD: 4229, ddPercent: 36 },
    { age: 78, activeMembers: 2147, ddMembers: 764, avgDD: 4781, ddPercent: 36 },
    { age: 79, activeMembers: 1716, ddMembers: 577, avgDD: 5583, ddPercent: 34 },
    { age: 80, activeMembers: 1259, ddMembers: 444, avgDD: 3820, ddPercent: 35 }
  ];

  // Combined comparison data
  const comparisonData = germanyData.map((g, index) => ({
    age: g.age,
    germanyDDPercent: g.ddPercent,
    usDDPercent: usData[index]?.ddPercent || 0,
    germanyAvgDD: g.avgDD,
    usAvgDD: usData[index]?.avgDD || 0,
    germanyMembers: g.activeMembers,
    usMembers: usData[index]?.activeMembers || 0
  }));

  // Age group comparison
  const ageGroupComparison = [
    { 
      ageGroup: '18-24',
      germanyDDPercent: 37,
      usDDPercent: 33,
      germanyMembers: 8577,
      usMembers: 24239,
      germanyAvgDD: 2829,
      usAvgDD: 2730
    },
    { 
      ageGroup: '25-34',
      germanyDDPercent: 46,
      usDDPercent: 40,
      germanyMembers: 14498,
      usMembers: 60927,
      germanyAvgDD: 4065,
      usAvgDD: 4920
    },
    { 
      ageGroup: '35-44',
      germanyDDPercent: 53,
      usDDPercent: 41,
      germanyMembers: 10518,
      usMembers: 61670,
      germanyAvgDD: 5010,
      usAvgDD: 5697
    },
    { 
      ageGroup: '45-54',
      germanyDDPercent: 58,
      usDDPercent: 38,
      germanyMembers: 6384,
      usMembers: 51392,
      germanyAvgDD: 6113,
      usAvgDD: 6059
    },
    { 
      ageGroup: '55-64',
      germanyDDPercent: 59,
      usDDPercent: 37,
      germanyMembers: 4720,
      usMembers: 51648,
      germanyAvgDD: 6331,
      usAvgDD: 5433
    },
    { 
      ageGroup: '65-74',
      germanyDDPercent: 52,
      usDDPercent: 37,
      germanyMembers: 2162,
      usMembers: 35445,
      germanyAvgDD: 4740,
      usAvgDD: 4645
    },
    { 
      ageGroup: '75-80',
      germanyDDPercent: 47,
      usDDPercent: 36,
      germanyMembers: 1196,
      usMembers: 11152,
      germanyAvgDD: 3876,
      usAvgDD: 4474
    }
  ];

  // Calculate totals
  const germanyTotal = germanyData.reduce((sum, d) => sum + d.activeMembers, 0);
  const germanyDDTotal = germanyData.reduce((sum, d) => sum + d.ddMembers, 0);
  const germanyOverallPercent = ((germanyDDTotal / germanyTotal) * 100).toFixed(1);

  const usTotal = usData.reduce((sum, d) => sum + d.activeMembers, 0);
  const usDDTotal = usData.reduce((sum, d) => sum + d.ddMembers, 0);
  const usOverallPercent = ((usDDTotal / usTotal) * 100).toFixed(1);

  // Radar chart data for regional comparison
  const radarData = [
    {
      metric: 'Young (18-24)',
      Germany: 37,
      US: 33,
      fullMark: 70
    },
    {
      metric: 'Prime (25-44)',
      Germany: 49.5,
      US: 40.5,
      fullMark: 70
    },
    {
      metric: 'Peak (45-64)',
      Germany: 58.5,
      US: 37.5,
      fullMark: 70
    },
    {
      metric: 'Senior (65+)',
      Germany: 49.5,
      US: 36.5,
      fullMark: 70
    },
    {
      metric: 'Overall',
      Germany: parseFloat(germanyOverallPercent),
      US: parseFloat(usOverallPercent),
      fullMark: 70
    }
  ];

  // Custom tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border rounded-lg shadow-lg">
          <p className="font-semibold">{label}</p>
          {payload.map((entry, index) => {
            const name = entry.name || entry.dataKey || '';
            let displayValue = entry.value;
            
            if (name.toLowerCase().includes('avgdd') || name.toLowerCase().includes('amount')) {
              displayValue = formatCurrency(entry.value);
            } else if (name.toLowerCase().includes('percent') || name.toLowerCase().includes('%')) {
              displayValue = `${entry.value}%`;
            } else {
              displayValue = entry.value.toLocaleString();
            }
            
            return (
              <p key={index} style={{ color: entry.color }}>
                {name}: {displayValue}
              </p>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="space-y-8">
      {/* Back Button */}
      <button
        onClick={() => navigate('/analysis')}
        className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Back to Analysis List</span>
      </button>

      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold text-gray-900">Silvur Credit Union Global Analysis</h2>
          <p className="text-gray-600 mt-1">Comparative analysis of direct deposit adoption patterns: Germany vs United States</p>
        </div>
        <div className="flex items-center space-x-3">
          <Globe className="w-5 h-5 text-gray-500" />
          <div className="text-sm text-gray-500">
            Combined: {(germanyTotal + usTotal).toLocaleString()} members
          </div>
        </div>
      </div>

      {/* Region Selector - Sticky */}
      <div className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm py-4 -mx-8 px-8 border-b-2 border-gray-200 shadow-md mb-4">
        <div className="flex justify-center space-x-4">
          <button
            onClick={() => setSelectedRegion('germany')}
            className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
              selectedRegion === 'germany' 
                ? 'bg-blue-600 text-white shadow-lg' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            🇩🇪 Germany
          </button>
          <button
            onClick={() => setSelectedRegion('us')}
            className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
              selectedRegion === 'us' 
                ? 'bg-red-600 text-white shadow-lg' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            🇺🇸 United States
          </button>
          <button
            onClick={() => setSelectedRegion('both')}
            className={`px-6 py-3 rounded-lg font-semibold transition-colors ${
              selectedRegion === 'both' 
                ? 'bg-purple-600 text-white shadow-lg' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            🌍 Compare Both
          </button>
        </div>
      </div>

      {/* Regional Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Germany Card */}
        <div className="bg-gradient-to-br from-blue-600 to-indigo-600 text-white p-8 rounded-xl shadow-lg">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold">🇩🇪 Germany</h3>
            <Users className="w-8 h-8 text-blue-200" />
          </div>
          <div className="space-y-4">
            <div>
              <div className="text-4xl font-bold mb-1">{germanyOverallPercent}%</div>
              <div className="text-blue-200">Overall DD Adoption</div>
            </div>
            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-blue-400">
              <div>
                <div className="text-2xl font-bold">{germanyTotal.toLocaleString()}</div>
                <div className="text-sm text-blue-200">Total Members</div>
              </div>
              <div>
                <div className="text-2xl font-bold">{germanyDDTotal.toLocaleString()}</div>
                <div className="text-sm text-blue-200">DD Members</div>
              </div>
            </div>
            <div className="pt-4 border-t border-blue-400">
              <div className="text-lg font-semibold mb-2">Key Characteristics:</div>
              <ul className="text-sm text-blue-100 space-y-1">
                <li>• Peak adoption: 62% (ages 49-61)</li>
                <li>• Highest avg DD: $7,803 (age 60)</li>
                <li>• Strong mid-career growth</li>
              </ul>
            </div>
          </div>
        </div>

        {/* United States Card */}
        <div className="bg-gradient-to-br from-red-600 to-pink-600 text-white p-8 rounded-xl shadow-lg">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-2xl font-bold">🇺🇸 United States</h3>
            <Users className="w-8 h-8 text-red-200" />
          </div>
          <div className="space-y-4">
            <div>
              <div className="text-4xl font-bold mb-1">{usOverallPercent}%</div>
              <div className="text-red-200">Overall DD Adoption</div>
            </div>
            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-red-400">
              <div>
                <div className="text-2xl font-bold">{usTotal.toLocaleString()}</div>
                <div className="text-sm text-red-200">Total Members</div>
              </div>
              <div>
                <div className="text-2xl font-bold">{usDDTotal.toLocaleString()}</div>
                <div className="text-sm text-red-200">DD Members</div>
              </div>
            </div>
            <div className="pt-4 border-t border-red-400">
              <div className="text-lg font-semibold mb-2">Key Characteristics:</div>
              <ul className="text-sm text-red-100 space-y-1">
                <li>• Peak adoption: 43% (age 37)</li>
                <li>• Highest avg DD: $6,209 (age 49)</li>
                <li>• Larger member base (6.5x)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Regional Performance Radar Chart */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <Target className="w-6 h-6 text-purple-600" />
          <span>Regional DD Adoption Performance</span>
        </h3>
        <div className="mb-4 p-4 bg-purple-50 rounded-lg">
          <p className="text-purple-900">
            Germany consistently outperforms the US across all age segments, with a 10-20 percentage point advantage
          </p>
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <RadarChart data={radarData}>
            <PolarGrid />
            <PolarAngleAxis dataKey="metric" />
            <PolarRadiusAxis angle={90} domain={[0, 70]} />
            <Radar name="Germany" dataKey="Germany" stroke="#2563EB" fill="#3B82F6" fillOpacity={0.6} />
            <Radar name="United States" dataKey="US" stroke="#DC2626" fill="#EF4444" fillOpacity={0.6} />
            <Legend />
            <Tooltip />
          </RadarChart>
        </ResponsiveContainer>
      </div>

      {/* Direct Comparison Line Chart */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <TrendingUp className="w-6 h-6 text-green-600" />
          <span>
            {selectedRegion === 'germany' && 'DD Adoption Rate by Age: Germany'}
            {selectedRegion === 'us' && 'DD Adoption Rate by Age: United States'}
            {selectedRegion === 'both' && 'DD Adoption Rate by Age: Germany vs US'}
          </span>
        </h3>
        <div className="mb-4 p-4 bg-green-50 rounded-lg">
          <p className="text-green-900">
            {selectedRegion === 'germany' && 'Germany shows strong adoption growth from 17% at age 18 to peak of 62% at ages 49-61, demonstrating excellent mid-career engagement'}
            {selectedRegion === 'us' && 'United States adoption climbs from 25% at age 18 to peak of 43% at age 37, then gradually declines through retirement years'}
            {selectedRegion === 'both' && 'Germany maintains 10-25 percentage point higher DD adoption across most age ranges, with the gap widening in mid-career years (35-64)'}
          </p>
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="age" 
              label={{ value: 'Age', position: 'insideBottom', offset: -5 }}
            />
            <YAxis 
              domain={[0, 70]}
              ticks={[0, 10, 20, 30, 40, 50, 60, 70]}
              tickFormatter={(value) => `${value}%`}
              label={{ value: 'DD Adoption %', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            {(selectedRegion === 'germany' || selectedRegion === 'both') && (
              <Line
                type="monotone"
                dataKey="germanyDDPercent"
                stroke="#2563EB"
                strokeWidth={3}
                dot={false}
                name="Germany DD %"
              />
            )}
            {(selectedRegion === 'us' || selectedRegion === 'both') && (
              <Line
                type="monotone"
                dataKey="usDDPercent"
                stroke="#DC2626"
                strokeWidth={3}
                dot={false}
                name="US DD %"
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Age Group Comparison Chart */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <BarChart3 className="w-6 h-6 text-indigo-600" />
          <span>DD Adoption by Age Group: Regional Comparison</span>
        </h3>
        <div className="mb-4 p-4 bg-indigo-50 rounded-lg">
          <p className="text-indigo-900">
            The adoption gap is largest in the 45-64 age group, where Germany achieves 58-59% vs US's 37-38%
          </p>
        </div>
        <ResponsiveContainer width="100%" height={350}>
          <BarChart data={ageGroupComparison}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="ageGroup" />
            <YAxis 
              domain={[0, 70]}
              ticks={[0, 10, 20, 30, 40, 50, 60, 70]}
              tickFormatter={(value) => `${value}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Bar dataKey="germanyDDPercent" fill="#3B82F6" name="Germany DD %" />
            <Bar dataKey="usDDPercent" fill="#EF4444" name="US DD %" />
          </BarChart>
        </ResponsiveContainer>
        
        {/* Detailed comparison table */}
        <div className="mt-6 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Age Group</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DE Members</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DE DD %</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">US Members</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">US DD %</th>
                <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Gap</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {ageGroupComparison.map((item, index) => (
                <tr key={index}>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{item.ageGroup}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">{item.germanyMembers.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-blue-600 text-right">{item.germanyDDPercent}%</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">{item.usMembers.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-red-600 text-right">{item.usDDPercent}%</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-bold text-green-600 text-right">
                    +{(item.germanyDDPercent - item.usDDPercent).toFixed(0)} pts
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Average DD Amount Comparison */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <DollarSign className="w-6 h-6 text-green-600" />
          <span>
            {selectedRegion === 'germany' && 'Average Direct Deposit Amount by Age: Germany'}
            {selectedRegion === 'us' && 'Average Direct Deposit Amount by Age: United States'}
            {selectedRegion === 'both' && 'Average Direct Deposit Amount: Germany vs US'}
          </span>
        </h3>
        <div className="mb-4 p-4 bg-green-50 rounded-lg">
          <p className="text-green-900">
            {selectedRegion === 'germany' && 'Germany DD amounts grow from $1,558 at age 18 to peak at $7,803 at age 60, reflecting strong career progression'}
            {selectedRegion === 'us' && 'United States DD amounts grow from $1,583 at age 18 to peak at $6,209 at age 49, showing solid but lower earning patterns'}
            {selectedRegion === 'both' && 'DD amounts are comparable, with the US slightly higher in prime earning years (25-44), while Germany peaks higher at age 60'}
          </p>
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={comparisonData.filter(d => d.germanyAvgDD > 0 && d.usAvgDD > 0)}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="age" 
              label={{ value: 'Age', position: 'insideBottom', offset: -5 }}
            />
            <YAxis 
              domain={[0, 9000]}
              ticks={[0, 1500, 3000, 4500, 6000, 7500, 9000]}
              tickFormatter={(value) => `$${value}`}
              label={{ value: 'Avg DD Amount', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            {(selectedRegion === 'germany' || selectedRegion === 'both') && (
              <Line
                type="monotone"
                dataKey="germanyAvgDD"
                stroke="#2563EB"
                strokeWidth={3}
                dot={false}
                name="Germany Avg DD"
              />
            )}
            {(selectedRegion === 'us' || selectedRegion === 'both') && (
              <Line
                type="monotone"
                dataKey="usAvgDD"
                stroke="#DC2626"
                strokeWidth={3}
                dot={false}
                name="US Avg DD"
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Member Volume Comparison */}
      <div className="bg-white p-8 rounded-xl border shadow-sm">
        <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
          <Users className="w-6 h-6 text-purple-600" />
          <span>
            {selectedRegion === 'germany' && 'Member Volume Distribution by Age: Germany'}
            {selectedRegion === 'us' && 'Member Volume Distribution by Age: United States'}
            {selectedRegion === 'both' && 'Member Volume Distribution by Age: Germany vs US'}
          </span>
        </h3>
        <div className="mb-4 p-4 bg-purple-50 rounded-lg">
          <p className="text-purple-900">
            {selectedRegion === 'germany' && 'Germany shows peak membership at age 24 (1,974 members) with strong concentration in ages 20-34'}
            {selectedRegion === 'us' && 'United States has significantly larger member base, peaking around ages 30-40 with 6,000+ members per age'}
            {selectedRegion === 'both' && 'The US has 6.5x more members overall, with significantly larger volumes across all age ranges, particularly ages 25-70'}
          </p>
        </div>
        <ResponsiveContainer width="100%" height={400}>
          <ComposedChart data={comparisonData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="age" 
              label={{ value: 'Age', position: 'insideBottom', offset: -5 }}
            />
            {selectedRegion === 'both' ? (
              <>
                <YAxis 
                  yAxisId="left"
                  label={{ value: 'Germany Members', angle: -90, position: 'insideLeft' }}
                />
                <YAxis 
                  yAxisId="right"
                  orientation="right"
                  label={{ value: 'US Members', angle: 90, position: 'insideRight' }}
                />
              </>
            ) : (
              <YAxis 
                label={{ value: 'Members', angle: -90, position: 'insideLeft' }}
              />
            )}
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            {(selectedRegion === 'germany' || selectedRegion === 'both') && (
              <Area
                yAxisId={selectedRegion === 'both' ? "left" : undefined}
                type="monotone"
                dataKey="germanyMembers"
                fill="#BFDBFE"
                stroke="#3B82F6"
                fillOpacity={0.6}
                name="Germany Members"
              />
            )}
            {(selectedRegion === 'us' || selectedRegion === 'both') && (
              <Area
                yAxisId={selectedRegion === 'both' ? "right" : undefined}
                type="monotone"
                dataKey="usMembers"
                fill="#FECACA"
                stroke="#EF4444"
                fillOpacity={0.6}
                name="US Members"
              />
            )}
          </ComposedChart>
        </ResponsiveContainer>
      </div>

      {/* Region-Specific Detailed Tables */}
      {selectedRegion === 'germany' && (
        <div className="bg-white p-8 rounded-xl border shadow-sm">
          <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
            <BarChart3 className="w-6 h-6 text-blue-600" />
            <span>Germany: Detailed Member Data by Age Group</span>
          </h3>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-blue-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Age Group</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total Members</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DD Members</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DD Adoption %</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Avg DD Amount</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {ageGroupComparison.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{item.ageGroup}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">{item.germanyMembers.toLocaleString()}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">
                      {Math.round(item.germanyMembers * item.germanyDDPercent / 100).toLocaleString()}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-blue-600 text-right">
                      {item.germanyDDPercent}%
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">
                      {formatCurrency(item.germanyAvgDD)}
                    </td>
                  </tr>
                ))}
                <tr className="bg-blue-100 font-bold">
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">Total</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">{germanyTotal.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">{germanyDDTotal.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-blue-700 text-right">{germanyOverallPercent}%</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {selectedRegion === 'us' && (
        <div className="bg-white p-8 rounded-xl border shadow-sm">
          <h3 className="text-2xl font-semibold mb-6 flex items-center space-x-2">
            <BarChart3 className="w-6 h-6 text-red-600" />
            <span>United States: Detailed Member Data by Age Group</span>
          </h3>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-red-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Age Group</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total Members</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DD Members</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">DD Adoption %</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Avg DD Amount</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {ageGroupComparison.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{item.ageGroup}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">{item.usMembers.toLocaleString()}</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">
                      {Math.round(item.usMembers * item.usDDPercent / 100).toLocaleString()}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-semibold text-red-600 text-right">
                      {item.usDDPercent}%
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 text-right">
                      {formatCurrency(item.usAvgDD)}
                    </td>
                  </tr>
                ))}
                <tr className="bg-red-100 font-bold">
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">Total</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">{usTotal.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">{usDDTotal.toLocaleString()}</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-red-700 text-right">{usOverallPercent}%</td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 text-right">-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* REGIONAL DIFFERENCES & OPPORTUNITIES SECTION */}
      <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white p-8 rounded-xl">
        <h2 className="text-3xl font-bold mb-6 flex items-center space-x-3">
          <Globe className="w-10 h-10" />
          <span>Regional Differences & Strategic Opportunities</span>
        </h2>
        <p className="text-slate-100 text-lg mb-8">
          Comprehensive analysis of key differences between Germany and United States markets with actionable recommendations
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Germany Strengths */}
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
            <h3 className="text-xl font-bold mb-4 flex items-center space-x-2">
              <Award className="w-6 h-6 text-blue-300" />
              <span>🇩🇪 Germany: Strengths & Advantages</span>
            </h3>
            <ul className="space-y-3 text-white/90">
              <li className="flex items-start space-x-2">
                <span className="text-blue-300 font-bold mt-1">•</span>
                <span><strong>Superior DD Adoption:</strong> 48.1% overall vs US's 38.8% - a 9.3 percentage point advantage</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-blue-300 font-bold mt-1">•</span>
                <span><strong>Peak Performance:</strong> Achieves 62% adoption in ages 49-61, showing strong mid-career banking relationships</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-blue-300 font-bold mt-1">•</span>
                <span><strong>Consistent Growth:</strong> Steady adoption curve from 17% (age 18) to 62% (peak), indicating effective member lifecycle management</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-blue-300 font-bold mt-1">•</span>
                <span><strong>Higher Senior Engagement:</strong> Maintains 47-52% adoption for ages 65-75 vs US's 35-39%</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-blue-300 font-bold mt-1">•</span>
                <span><strong>Peak DD Amount:</strong> $7,803 at age 60, demonstrating strong high-value relationships</span>
              </li>
            </ul>
          </div>

          {/* US Opportunities */}
          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg">
            <h3 className="text-xl font-bold mb-4 flex items-center space-x-2">
              <Target className="w-6 h-6 text-red-300" />
              <span>🇺🇸 United States: Challenges & Gaps</span>
            </h3>
            <ul className="space-y-3 text-white/90">
              <li className="flex items-start space-x-2">
                <span className="text-orange-300 font-bold mt-1">•</span>
                <span><strong>Lower Overall Adoption:</strong> 38.8% vs Germany's 48.1% - significant 9.3 point gap represents major opportunity</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-orange-300 font-bold mt-1">•</span>
                <span><strong>Flat Mid-Career Adoption:</strong> Plateaus at 40-43% for ages 25-44, never exceeding Germany's baseline</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-orange-300 font-bold mt-1">•</span>
                <span><strong>Peak Performance Gap:</strong> Maximum 43% (age 37) vs Germany's 62% - a 19 point difference in best performance</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-orange-300 font-bold mt-1">•</span>
                <span><strong>Declining Adoption Pattern:</strong> Drops to 35-38% for ages 45-64, exactly when Germany peaks at 58-59%</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-orange-300 font-bold mt-1">•</span>
                <span><strong>Volume Without Engagement:</strong> 6.5x more members but proportionally fewer DD relationships</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Key Differences Analysis */}
      <div className="bg-white p-8 rounded-xl border-2 border-slate-300 shadow-lg">
        <h3 className="text-2xl font-bold mb-6 text-gray-900 flex items-center space-x-2">
          <AlertCircle className="w-8 h-8 text-slate-600" />
          <span>Critical Regional Differences</span>
        </h3>
        
        <div className="space-y-6">
          {/* Difference 1 */}
          <div className="border-l-4 border-blue-600 pl-4 pr-4 py-3 bg-blue-50 rounded-r-lg">
            <h4 className="text-lg font-bold text-gray-900 mb-2">1. Adoption Rate Gap Across All Ages</h4>
            <p className="text-gray-700 mb-3">
              Germany maintains a consistent 10-25 percentage point advantage across nearly every age bracket. This isn't 
              just a single demographic issue - it's a systemic difference in DD penetration.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-3">
              <div className="bg-white p-3 rounded">
                <div className="text-sm text-gray-600">Ages 18-24</div>
                <div className="text-xl font-bold text-blue-600">+4 pts</div>
                <div className="text-xs text-gray-500">Germany advantage</div>
              </div>
              <div className="bg-white p-3 rounded">
                <div className="text-sm text-gray-600">Ages 25-44</div>
                <div className="text-xl font-bold text-blue-600">+9 pts</div>
                <div className="text-xs text-gray-500">Germany advantage</div>
              </div>
              <div className="bg-white p-3 rounded">
                <div className="text-sm text-gray-600">Ages 45-64</div>
                <div className="text-xl font-bold text-blue-600">+21 pts</div>
                <div className="text-xs text-gray-500">Germany advantage</div>
              </div>
            </div>
          </div>

          {/* Difference 2 */}
          <div className="border-l-4 border-green-600 pl-4 pr-4 py-3 bg-green-50 rounded-r-lg">
            <h4 className="text-lg font-bold text-gray-900 mb-2">2. Peak Performance Timing Divergence</h4>
            <p className="text-gray-700 mb-3">
              Germany's peak adoption occurs at ages 49-61 (62%), while the US peaks much earlier at age 37 (43%) and 
              then declines. This suggests Germany successfully deepens relationships over time, while US engagement weakens.
            </p>
            <div className="bg-white p-4 rounded mt-3">
              <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <div className="text-center sm:text-left">
                  <div className="text-sm text-gray-600">Germany Peak</div>
                  <div className="text-xl sm:text-2xl font-bold text-green-600">Ages 49-61: 62%</div>
                </div>
                <ArrowRight className="w-8 h-8 text-gray-400 rotate-90 sm:rotate-0" />
                <div className="text-center sm:text-right">
                  <div className="text-sm text-gray-600">US Peak</div>
                  <div className="text-xl sm:text-2xl font-bold text-orange-600">Age 37: 43%</div>
                </div>
              </div>
            </div>
          </div>

          {/* Difference 3 */}
          <div className="border-l-4 border-purple-600 pl-4 pr-4 py-3 bg-purple-50 rounded-r-lg">
            <h4 className="text-lg font-bold text-gray-900 mb-2">3. Member Base Scale vs Engagement Quality</h4>
            <p className="text-gray-700 mb-3">
              The US has 6.5x more members (326,276 vs 50,055) but significantly lower engagement. This massive scale 
              advantage isn't translating to proportional DD relationships, suggesting untapped potential.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-3">
              <div className="bg-white p-4 rounded">
                <div className="text-sm text-gray-600 mb-2">Germany</div>
                <div className="text-2xl sm:text-3xl font-bold text-purple-600 mb-1">24,041</div>
                <div className="text-sm text-gray-700">DD Members (48.1% of 50K)</div>
              </div>
              <div className="bg-white p-4 rounded">
                <div className="text-sm text-gray-600 mb-2">United States</div>
                <div className="text-2xl sm:text-3xl font-bold text-purple-600 mb-1">126,495</div>
                <div className="text-sm text-gray-700">DD Members (38.8% of 326K)</div>
              </div>
            </div>
            <div className="mt-3 p-3 bg-yellow-100 rounded">
              <p className="text-sm text-yellow-900">
                <strong>Opportunity:</strong> If US matched Germany's 48.1% rate, it would add <strong>30,395 DD relationships</strong> 
                (from 126K to 157K) - a 24% increase in DD engagement.
              </p>
            </div>
          </div>

          {/* Difference 4 */}
          <div className="border-l-4 border-orange-600 pl-4 pr-4 py-3 bg-orange-50 rounded-r-lg">
            <h4 className="text-lg font-bold text-gray-900 mb-2">4. Mid-Career Engagement Trajectory</h4>
            <p className="text-gray-700 mb-3">
              The most striking difference occurs in the 45-64 age range. Germany achieves 58-59% adoption (peak earning years), 
              while the US drops to 36-38% during the same period - a 20-22 percentage point gap at the most valuable life stage.
            </p>
            <div className="bg-white p-4 rounded mt-3 overflow-hidden">
              <ResponsiveContainer width="100%" height={150}>
                <BarChart data={[
                  { ageGroup: '25-34', Germany: 46, US: 40 },
                  { ageGroup: '35-44', Germany: 53, US: 41 },
                  { ageGroup: '45-54', Germany: 58, US: 38 },
                  { ageGroup: '55-64', Germany: 59, US: 37 }
                ]}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="ageGroup" />
                  <YAxis domain={[0, 70]} />
                  <Tooltip />
                  <Bar dataKey="Germany" fill="#3B82F6" name="Germany %" />
                  <Bar dataKey="US" fill="#EF4444" name="US %" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Executive Summary */}
      <div className="bg-gray-900 text-white p-8 rounded-xl">
        <h2 className="text-3xl font-bold mb-6">Executive Summary: Global DD Performance</h2>
        
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          <div className="bg-blue-900/50 p-6 rounded-lg border border-blue-700">
            <div className="text-sm text-blue-300 mb-2">Overall Performance Gap</div>
            <div className="text-4xl font-bold mb-2">9.3%</div>
            <div className="text-blue-200">Germany leads US in DD adoption</div>
            <div className="text-sm text-blue-300 mt-3">48.1% vs 38.8% overall rate</div>
          </div>
          
          <div className="bg-green-900/50 p-6 rounded-lg border border-green-700">
            <div className="text-sm text-green-300 mb-2">Largest Opportunity</div>
            <div className="text-4xl font-bold mb-2">Ages 45-64</div>
            <div className="text-green-200">21 point adoption gap</div>
            <div className="text-sm text-green-300 mt-3">103K US members in this cohort</div>
          </div>
          
          <div className="bg-purple-900/50 p-6 rounded-lg border border-purple-700">
            <div className="text-sm text-purple-300 mb-2">Total Potential</div>
            <div className="text-4xl font-bold mb-2">30,395</div>
            <div className="text-purple-200">Additional US DD members</div>
            <div className="text-sm text-purple-300 mt-3">If matching Germany's 48.1% rate</div>
          </div>
        </div>

        <div className="bg-white/10 p-6 rounded-lg">
          <h3 className="text-xl font-bold mb-4">Key Takeaways</h3>
          <div className="space-y-3 text-gray-100">
            <p>
              <strong>1. Systematic Advantage:</strong> Germany's superior performance isn't isolated to one age group - 
              it's consistent across the entire member lifecycle, suggesting transferable operational excellence.
            </p>
            <p>
              <strong>2. Scale vs Quality Trade-off:</strong> The US has 6.5x more members but hasn't converted scale 
              into proportional engagement. The infrastructure exists; activation strategies need refinement.
            </p>
            <p>
              <strong>3. Mid-Career Critical Gap:</strong> The 20+ point adoption gap for ages 45-64 represents the 
              single largest missed opportunity, occurring during members' peak earning and banking needs.
            </p>
            <p>
              <strong>4. Compounding Lifetime Value:</strong> Germany's pattern of increasing adoption through age 60 
              suggests deeper, long-term relationships that compound value over decades - a model US operations should emulate.
            </p>
          </div>
        </div>
      </div>

      {/* Methodology Note */}
      <div className="bg-gray-50 p-6 rounded-xl border">
        <h4 className="font-semibold text-gray-900 mb-2">Analysis Methodology</h4>
        <p className="text-gray-700 text-sm leading-relaxed">
          This analysis compares direct deposit adoption patterns between Silvur Credit Union's Germany operations 
          (50,055 members) and United States operations (326,276 members) across ages 18-80. Regional data includes 
          active member counts, DD member counts, average DD amounts, and adoption percentages by age. Age group 
          aggregations use weighted averages based on member volumes. The comparison identifies systematic differences 
          in DD penetration, peak performance timing, and member engagement quality across both markets. All calculations 
          exclude data points with missing values to ensure accuracy.
        </p>
      </div>
    </div>
  );
};

export default Silvuranalysis;